module.exports = __webpack_public_path__ + "img/logo.e57828e3.png";